import React, { useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { getCurrentProfile, deleteAccount } from "../../actions/profile";
import { connect } from "react-redux";
import ProfileItem from "./ProfileItem";

const DisplayProfile = ({
  getCurrentProfile,
  deleteAccount,
  auth: { user },
  profile: { profile, loading },
}) => {
  useEffect(() => {
    getCurrentProfile();
  }, [getCurrentProfile]);

  return loading ? (
    <img
      src={require("../../images/load.gif")}
      alt="Loading . . . "
      className="load"
    />
  ) : (
    <div className="container-fluid " style={{ minHeight: "100vh" }}>
      <div className="row">
        <div className="col-10 mx-auto">
          <div className="row">
            <div className="col-md-6 col-sm-12 mx-auto d-flex flex-column align-items-center">
              <h1 className="large text-primary">Your Profile</h1>
              <p className="lead">
                <i className="fas fa-user"></i>Welcome {user && user.userName}
              </p>
              {profile !== null && profile.user !== null ? (
                <Fragment>
                  <ProfileItem profile={profile} user={profile.user} />
                  <div className="my-2">
                    <button
                      className="btn btn-danger"
                      onClick={() => deleteAccount()}
                    >
                      <i className="fas fa-user-minus"></i> Delete My Account
                    </button>
                  </div>
                </Fragment>
              ) : (
                <Fragment>
                  <p>You have not yet setup a profile, please add some info</p>
                  <Link to="/create-profile" className="btn btn-primary my-1">
                    Create Profile
                  </Link>
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

DisplayProfile.propTypes = {
  getCurrentProfile: PropTypes.func.isRequired,
  deleteAccount: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile,
});

export default connect(mapStateToProps, {
  getCurrentProfile,
  deleteAccount,
})(DisplayProfile);
